import React from "react";
import AttendanceReport from "../../components/Attendance/attendanceReport.component";

export default class AttendanceScreen extends React.Component {
  render() {
    return <AttendanceReport />;
  }
}
